import { render, staticRenderFns } from "./RecordRole.vue?vue&type=template&id=338a0077&"
import script from "./RecordRole.vue?vue&type=script&lang=js&"
export * from "./RecordRole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports